import { render, staticRenderFns } from "./ResetPw.vue?vue&type=template&id=76631467&scoped=true&"
import script from "./ResetPw.vue?vue&type=script&lang=js&"
export * from "./ResetPw.vue?vue&type=script&lang=js&"
import style0 from "./ResetPw.vue?vue&type=style&index=0&id=76631467&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76631467",
  null
  
)

export default component.exports